/// <amd-module name="xss/index" />
const f = () => {
    (<any>window).define("xss", [], () => {
        return (<any>window).filterXSS;
    });
}
f();